import { Component } from 'preact';
import Loader from './loader';
// import Loadable from 'preact-loadable';

// import Questions from './questions';
import Start from './start';

import { SKIP_START } from '../constants/';


// let LoadableQuestions = new Loadable({
//   loader: () => import('./questions'),
//   LoadingComponent: Loader,
//   delay: 200,
//   webpackRequireWeakId: () => require.resolveWeak('./questions'),
// });

export default class App extends Component {

	state = {
		startComplete: false,
		move: false,
		Questions: null
	}

	async componentDidMount() {
  		const questions = await import(/* webpackChunkName: "chunk-contactme" */ './questions');
		this.setState({ Questions: questions.default });
	}

	getClasses = () => {
		if(typeof navigator === 'object') {
			let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
			if(isSafari) {
				return 'safari'
			}
		}
	}

	startComplete = () => {
		this.setState({ startComplete: true }, () => setTimeout( () => this.setState({ move: true }), 1000 ) )
	}

	getContent = () => {
		const { startComplete, move } = this.state;
		if(SKIP_START && this.state.Questions) {
			return (
				<div id="app" className={ this.getClasses() }>
					<div className={`questions-container ${ move ? 'move' : '' }`}>
						<this.state.Questions />
					</div>
				</div>
			)
		}
		let Questions = this.state.Questions;
		return (
			<div id="app" className={ this.getClasses() }>
				<div className={`start-container ${ move ? 'move' : '' }`}>
					<Start startComplete={this.startComplete} />
				</div>
				{
					startComplete &&
					<div className={`questions-container ${ move ? 'move' : '' }`}>
						<Questions />
					</div>
				}
			</div>
		)
	}

	render() {
		return this.getContent();
	}
}



// WEBPACK FOOTER //
// ./components/app.js